import { openResolvedInNewTab, type Invoice } from '@etiquetachef/types';
import { getInvoiceDocumentUrlCallable } from '@/lib/callables';
import { reportNonFatal, serializeError } from '@/lib/errorReport';

/**
 * Abre o PDF de uma fatura pelo link ATUAL do gateway, numa aba nova.
 *
 * Origem: #783 — 2026-09-29 12:50 +0200 (achado na tela do cliente do CRM, #776).
 *
 * Por quê: o `pdf_url` gravado pelo webhook do Stripe expira — o owner abriu
 * uma fatura antiga e a Stripe respondeu "Este link expirou". A callable
 * `getInvoiceDocumentUrl` relê a fatura; a aba abre no clique
 * (`openResolvedInNewTab`), senão o bloqueador de pop-up a barra.
 *
 * Contrato: devolve `false` quando não há documento nenhum (quem chama
 * avisa). Falha da callable cai no `pdf_url` gravado e vai para o PostHog
 * (`invoice_pdf_link_failed`) — sem DevTools do cliente, é o único rastro.
 *
 * Usado por: `InvoiceActions`, `InvoicesPage` (admin). O CRM tem a
 * mesma chamada em `FinanceTab`.
 *
 * Issues: #783, #776.
 */
export function openInvoicePdf(tenantId: string, invoice: Invoice): Promise<boolean> {
  return openResolvedInNewTab(
    window,
    () =>
      getInvoiceDocumentUrlCallable({ tenantId, invoiceId: invoice.id })
        .then((out) => out.url)
        .catch((err: unknown) => {
          reportNonFatal('invoice_pdf_link_failed', { tenantId, invoiceId: invoice.id, ...serializeError(err) });
          throw err;
        }),
    invoice.pdf_url,
  );
}
